import { I18N } from 'aurelia-i18n';
import { mock, instance, when, anything, verify } from 'ts-mockito';
import { MfaVerification } from './mfa-verification';
import { Router } from 'aurelia-router';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { PostLoginRouteManager } from '../../helpers/post-login-route-manager';
import { MfaTwoFactorMethod } from '../../models/mfa/mfa-two-factor-method';

describe('NewPortalWeb', () => {
	describe('components', () => {
		describe('mfa-verification', () => {
			let component: MfaVerification;
			const mockI18N: I18N = mock(I18N);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockElement: Element = mock(Element);
			const mockState: State = mock(State);
			const mockRouter: Router = mock(Router);
			const mockPostLoginRouteManager: PostLoginRouteManager = mock(PostLoginRouteManager);

			const i18next = {
				t: (a, b) => a
			};

			beforeEach(() => {
				when(mockI18N.i18next).thenReturn(i18next);

				component = new MfaVerification(
					instance(mockPayrazrService),
					instance(mockState),
					instance(mockRouter),
					instance(mockI18N),
					instance(mockPostLoginRouteManager),
					instance(mockElement));
			});

			it('should initialize mfa-verification component', () => {
				expect(component).toBeTruthy();
			});

			describe('attached', () => {
				it('twoFactorPreferredType should default to MfaTwoFactorMethod.NotSet', () => {
					component.attached();
					expect(component.twoFactorPreferredType).toEqual(MfaTwoFactorMethod.NotSet);
				});
			});
		});
	});
});
